{
  "printedAt": "Printed {{at}}",
  "vatNumber": "VAT no.",
  "account": "Account",
  "amount": "Amount",
  "invalidRange": "The end date is before the start date.",
  "exportCsv": "Export CSV",
  "exportedCsv": "Report exported",
  "profitAndLoss": {
    "title": "Profit and loss",
    "comparison": "Comparison",
    "compareWith": "Compare with",
    "compareModes": {
      "off": "No comparison",
      "previous": "Previous period",
      "lastYear": "Same period last year",
      "custom": "Custom period"
    },
    "compareFrom": "Comparison period from",
    "compareTo": "Comparison period to",
    "comparedWith": "compared with {{period}}",
    "current": "This period",
    "compared": "Comparison",
    "difference": "Difference",
    "revenue": "Revenue",
    "expenses": "Expenses",
    "totalRevenue": "Total revenue",
    "totalExpenses": "Total expenses",
    "netProfit": "Net profit",
    "netLoss": "Net loss",
    "noRevenue": "No revenue in this period.",
    "noExpenses": "No expenses in this period.",
    "empty": "Nothing posted to income or expense accounts in this period.",
    "emptyBody": "Choose another period.",
    "hint": "Amounts in <rial/>. Year-end closing entries are left out. Select an account to open its ledger for the period."
  },
  "balanceSheet": {
    "title": "Balance sheet",
    "asOf": "As of {{date}}",
    "asOfLabel": "As of date",
    "fiscalYearStart": "fiscal year from {{date}}",
    "computed": "Computed",
    "computedHint": "Worked out from income and expense accounts; not an account of its own.",
    "balanced": "Assets equal liabilities plus equity",
    "unbalanced": "Out of balance by {{amount}}",
    "assets": "Assets",
    "liabilities": "Liabilities",
    "equity": "Equity",
    "totalAssets": "Total assets",
    "totalLiabilities": "Total liabilities",
    "totalEquity": "Total equity",
    "totalLiabilitiesAndEquity": "Total liabilities and equity",
    "empty": "Nothing posted up to this date.",
    "emptyBody": "Choose a later date.",
    "hint": "Amounts in <rial/>. Current year earnings are this fiscal year's profit to date: select them to open the profit and loss. Select an account to open its ledger."
  },
  "generalLedger": {
    "title": "General ledger",
    "account": "Account",
    "chooseAccount": "Choose an account",
    "noChart": "Choosing an account needs access to the chart of accounts.",
    "openNamed": "Account statement: {{name}}",
    "hint": "Amounts in <rial/>. The balance runs on the account's normal side; a negative balance is shown in red. Every entry counts, year-end closing entries included. Printing prints the page on screen.",
    "party": {
      "label": "Party",
      "any": "All parties",
      "types": {
        "CUSTOMER": "Customer",
        "SUPPLIER": "Supplier"
      },
      "all": {
        "CUSTOMER": "All customers",
        "SUPPLIER": "All suppliers"
      },
      "search": "Search name, code or mobile…",
      "none": "No matches.",
      "failed": "Couldn't search. Try again.",
      "printed": "{{type}}: {{party}}"
    },
    "empty": {
      "title": "Choose an account",
      "body": "Pick a posting account to see its entries for the period, with the running balance and totals.",
      "noChart": "Open an account's ledger from the profit and loss, the balance sheet or the trial balance. Choosing one here needs access to the chart of accounts."
    },
    "headerAccount": {
      "title": "This is a header account",
      "body": "A header account only groups sub-accounts and has no entries of its own. Choose a posting account.",
      "bodyNamed": "{{account}} only groups sub-accounts and has no entries of its own. Choose a posting account under it."
    },
    "columns": {
      "date": "Date",
      "entry": "Entry",
      "description": "Description",
      "party": "Party",
      "debit": "Debit",
      "credit": "Credit",
      "balance": {
        "DEBIT": "Balance (debit)",
        "CREDIT": "Balance (credit)"
      },
      "balanceLabel": "Balance"
    },
    "openingBalance": "Opening balance",
    "broughtForward": "Brought forward",
    "carriedForward": "Carried forward to the next page",
    "periodTotals": "Totals for the whole period",
    "closingBalance": "Closing balance at {{date}}",
    "noLinesInPeriod": "No entries in this period.",
    "linesRange": "Lines {{from}}–{{to}} of {{total}}"
  },
  "vatReturn": {
    "title": "VAT return",
    "bySupplier": {
      "title": "Input tax by supplier",
      "hint": "Input VAT is reclaimable only on a tax invoice showing the supplier's VATIN. Expenses that name no supplier are shown together.",
      "supplier": "Supplier",
      "vatin": "VATIN",
      "documents": "Documents",
      "noSupplier": "Expenses naming no supplier",
      "missing": "No VATIN",
      "flagged_one": "{{count}} line has no VATIN: check its tax invoices before reclaiming.",
      "flagged_other": "{{count}} lines have no VATIN: check their tax invoices before reclaiming.",
      "empty": "No input tax in this period."
    },
    "category": "Category",
    "categories": {
      "STANDARD": "Standard-rated",
      "ZERO": "Zero-rated",
      "EXEMPT": "Exempt",
      "OUT_OF_SCOPE": "Out of scope"
    },
    "net": "Net amount",
    "tax": "VAT",
    "total": "Total",
    "output": "Output tax (supplies)",
    "input": "Input tax (purchases)",
    "noSupplies": "No supplies in this period.",
    "noPurchases": "No purchases with VAT in this period.",
    "summary": "Net VAT",
    "outputTax": "Output tax",
    "lessInputTax": "Less input tax",
    "inputTax": "Input tax",
    "netPayable": "Net VAT payable",
    "netRefundable": "Net VAT refundable",
    "reconciliation": "Reconciliation with the ledger",
    "line": "Line",
    "account": "VAT account",
    "perDocuments": "Documents",
    "perLedger": "Ledger",
    "difference": "Difference",
    "notMapped": "Not mapped",
    "setUpMapping": "Set up in Account mapping",
    "mismatch": "Differs from the documents",
    "agree": "Documents and ledger agree",
    "differ": {
      "title": "Documents and ledger differ",
      "body": "What the documents posted to the VAT accounts doesn't match the documents, usually because a VAT account was re-mapped after posting or data was corrected by hand. Open the account's ledger to find those entries before filing.",
      "unmapped": "A VAT role has no account mapped, so its ledger amount shows as zero."
    },
    "hint": "Amounts in <rial/>. The tax point is the document date, and amounts use each posted document's own rate. Opens on last month: choose your return period above.",
    "manual": {
      "title": "Other VAT movements",
      "body": "Manual journals on the VAT accounts in this period: paying or settling VAT, corrections and opening balances. They are not part of the difference above, which compares what the documents posted.",
      "output": "Output VAT account",
      "input": "Input VAT account",
      "net": "Net"
    }
  },
  "total": "Total",
  "asOf": "As of {{date}}",
  "asOfLabel": "As of",
  "warehouse": "Warehouse",
  "allWarehouses": "All warehouses",
  "clearSearch": "Clear search",
  "rowsRange": "Rows {{from}}–{{to}} of {{total}}",
  "printedWarehouse": "Warehouse: {{warehouse}}",
  "movementsHint": "Open the stock movements",
  "emptySearch": {
    "title": "Nothing matches your search.",
    "body": "Try another name, code or SKU, or clear the search."
  },
  "issues": {
    "title": "Check the report filters",
    "endBeforeStart": "The end date is before the start date.",
    "rangeTooLong": "A report covers at most {{years}} years. Choose a shorter period.",
    "fields": {
      "from": "Start date",
      "to": "End date",
      "asOf": "As of date",
      "groupBy": "Grouping",
      "warehouseId": "Warehouse",
      "terminalId": "Till",
      "userId": "Cashier",
      "q": "Search",
      "sort": "Order",
      "page": "Page",
      "pageSize": "Rows per page"
    }
  },
  "productSearch": {
    "placeholder": "Search product name or SKU…",
    "label": "Search products"
  },
  "columns": {
    "code": "Code",
    "user": "User",
    "tillSales": "Till sales",
    "receipts": "Receipts",
    "refunds": "Refunds",
    "receiptCount": "Receipts (count)",
    "refundCount": "Refunds (count)",
    "tillSaleCount": "Till sales (count)",
    "customer": "Customer",
    "supplier": "Supplier",
    "product": "Product",
    "invoices": "Invoices",
    "creditNotes": "Credit notes",
    "invoiced": "Invoiced",
    "credited": "Credited",
    "netSales": "Net sales",
    "vat": "VAT",
    "totalWithVat": "Total with VAT",
    "quantitySold": "Sold",
    "quantityReturned": "Returned",
    "netQuantity": "Net quantity",
    "cost": "Cost",
    "grossProfit": "Gross profit",
    "margin": "Margin",
    "otherLines": "Lines not tied to a product",
    "purchases": "Purchases",
    "returns": "Returns",
    "purchased": "Purchased",
    "returned": "Returned",
    "netPurchases": "Net purchases",
    "quantityPurchased": "Bought",
    "quantitySentBack": "Sent back",
    "quantity": "Quantity",
    "averageCost": "Average cost",
    "value": "Value",
    "onHand": "On hand",
    "reorderLevel": "Reorder level",
    "shortfall": "Shortfall",
    "date": "Date",
    "till": "Till",
    "cashier": "Cashier",
    "sales": "Sales",
    "voided": "Voided",
    "gross": "Gross sales",
    "vatIncluded": "VAT included",
    "tillReturns": "Returns",
    "returnsVat": "VAT on returns",
    "net": "Net",
    "netBeforeVat": "Net before VAT",
    "tillDiscounts": "Discounts",
    "cash": "Cash",
    "card": "Card",
    "bankTransfer": "Bank transfer",
    "otherTender": "Other",
    "onAccount": "On account",
    "cashRefunds": "Cash refunds",
    "cardRefunds": "Card refunds",
    "variance": "Cash difference",
    "salesperson": "Salesperson",
    "netAfterReturns": "Net after returns",
    "collected": "Collected"
  },
  "hub": {
    "title": "Reports",
    "subtitle": "Every report you can open, by area. Each one prints, and keeps its filters in the link.",
    "sections": {
      "financial": "Financial",
      "sales": "Sales",
      "purchasing": "Purchasing",
      "inventory": "Inventory",
      "pos": "Point of sale",
      "work": "Work",
      "projects": "Projects"
    },
    "hints": {
      "trialBalance": "Opening, movement and closing balance of every account.",
      "profitAndLoss": "Revenue and expenses over a period, with an optional comparison.",
      "balanceSheet": "Assets, liabilities and equity on a date.",
      "cashFlow": "Where cash came from and went, by activity, from opening to closing balance.",
      "generalLedger": "Every entry on one account, with the running balance.",
      "vatReturn": "Output and input VAT for a return period, checked against the ledger.",
      "salesByCustomer": "Net sales per customer, largest first.",
      "salesByProduct": "Quantity, net sales, cost and gross profit per product.",
      "salesByPeriod": "Sales totals by month or by day.",
      "salesByUser": "Sales credited to whoever created the invoice, with till sales, receipts and refunds per user. To credit the salesperson instead, see Sales by salesperson.",
      "receivablesAging": "What each customer owes, by how long it is overdue.",
      "purchasesBySupplier": "Net purchases per supplier, largest first.",
      "purchasesByProduct": "Quantity bought and net purchases per product.",
      "payablesAging": "What you owe each supplier, by how long it is overdue.",
      "stockValuation": "Quantity and value at cost of every product on a date.",
      "lowStock": "Products at or below their reorder level, largest shortfall first.",
      "posSummary": "Till takings per day, till and cashier, with payments and cash differences.",
      "taskReport": "Open, overdue and blocked work, and on-time delivery by team, person and customer.",
      "projectProfitability": "Contract, billed, cost to date and margin per project, with what is collected and outstanding.",
      "projectBudgetVsActual": "Budget, committed and actual cost per project and cost category, on a date.",
      "projectUnbilledWork": "Billing items ready to invoice and billable costs not yet invoiced, per project.",
      "projectUtilisation": "Hours by person: approved, awaiting approval, billable, and against what their allocations expect.",
      "salesBySalesperson": "Sales credited to each invoice's salesperson: sold, returned and collected. To credit whoever created the invoice, see Sales and collections by user."
    }
  },
  "cashFlow": {
    "title": "Cash flow",
    "sections": {
      "operating": "Operating activities",
      "investing": "Investing activities",
      "financing": "Financing activities"
    },
    "net": {
      "operating": "Net cash from operating activities",
      "investing": "Net cash from investing activities",
      "financing": "Net cash from financing activities"
    },
    "noMovement": "No cash moved for these activities in this period.",
    "opening": "Cash and bank at the start of {{date}}",
    "netChange": "Net change in cash",
    "closing": "Cash and bank at the end of {{date}}",
    "empty": "No cash moved in this period, and there was no cash to start with.",
    "emptyBody": "Cash appears here once receipts, payments or expenses are posted to a cash or bank account. Choose another period.",
    "hint": "Amounts in <rial/>, direct method: money in is positive, money out negative. Each line is the account on the other side of the cash movement; select it to open its ledger for the period. Transfers between cash and bank accounts are left out."
  },
  "salesByCustomer": {
    "title": "Sales by customer",
    "searchPlaceholder": "Search customer name or code…",
    "searchLabel": "Search customers",
    "empty": "No sales in this period.",
    "emptyBody": "Only posted invoices, debit notes and credit notes count. Choose another period.",
    "hint": "Amounts in <rial/>, before VAT unless marked. Net sales are invoiced less credited. The total covers every customer, not only this page. Select a customer to open their statement."
  },
  "salesByProduct": {
    "title": "Sales by product",
    "empty": "No products sold in this period.",
    "emptyBody": "Only posted invoices and credit notes count. Choose another period.",
    "hint": "Amounts in <rial/>, before VAT. Returns on credit notes bring back quantity and cost; allowances reduce net sales only. The margin is gross profit as a share of net sales. Totals cover every product."
  },
  "salesByPeriod": {
    "title": "Sales by period",
    "groupBy": "Group by",
    "groupings": {
      "month": "Month",
      "day": "Day"
    },
    "by": {
      "month": "By month",
      "day": "By day"
    },
    "empty": "No sales in this period.",
    "emptyBody": "Only posted invoices, debit notes and credit notes count. Choose another period.",
    "hint": "Amounts in <rial/>, before VAT unless marked. Credit notes count on their own date. Select a period to see its sales by customer."
  },
  "salesByUser": {
    "title": "Sales and collections by user",
    "noUser": "No recorded user",
    "empty": "No sales or collections in this period.",
    "emptyBody": "Only posted invoices, credit notes, receipts and refunds count. Choose another period.",
    "hint": "Amounts in <rial/>, before VAT. Sales go to whoever created the invoice, and a credit note to the seller of its invoice. Till sales are the part of net sales rung up on the user's own shifts, less their returns. Receipts and refunds go to whoever recorded them. Sales by salesperson credits each invoice's salesperson instead, so the two differ when someone else is the salesperson, as on a till sale to a customer with their own."
  },
  "purchasesBySupplier": {
    "title": "Purchases by supplier",
    "searchPlaceholder": "Search supplier name or code…",
    "searchLabel": "Search suppliers",
    "empty": "No purchases in this period.",
    "emptyBody": "Only posted purchases and supplier returns count. Choose another period.",
    "hint": "Amounts in <rial/>, before VAT unless marked. Net purchases are purchased less returned. The total covers every supplier, not only this page. Select a supplier to open their statement."
  },
  "purchasesByProduct": {
    "title": "Purchases by product",
    "empty": "No products bought in this period.",
    "emptyBody": "Only posted purchases and supplier returns count. Choose another period.",
    "hint": "Amounts in <rial/>, before VAT. Lines not tied to a product (services, freight) are grouped together. Totals cover every product."
  },
  "stockValuation": {
    "title": "Stock valuation",
    "empty": "No stock on hand on this date.",
    "emptyBody": "Goods appear here once they are received on a posted purchase or counted in with a stock adjustment. Choose a later date or another warehouse.",
    "hint": "Value at weighted-average cost at the end of the date. Over all warehouses, the total equals the inventory account in the ledger. Select a quantity to see how it moved."
  },
  "lowStock": {
    "title": "Low stock",
    "subtitle": "On hand now, at or below the reorder level",
    "groupBy": "Show",
    "groupings": {
      "total": "All warehouses together",
      "warehouse": "Each warehouse"
    },
    "empty": "Nothing is at or below its reorder level.",
    "emptyBody": "Set a reorder level on a product to be warned here before it runs out.",
    "hint": "The same rule as the “at or below reorder level” filter on Stock levels. Largest shortfall first. Select a quantity to see how it moved."
  },
  "posSummary": {
    "title": "Till sales summary",
    "allTills": "All tills",
    "allCashiers": "All cashiers",
    "onlyTill": "Show only this till",
    "onlyCashier": "Show only this cashier",
    "tillFilter": "Till: {{till}}",
    "cashierFilter": "Cashier: {{cashier}}",
    "printedTill": "Till: {{till}}",
    "printedCashier": "Cashier: {{cashier}}",
    "empty": "No till sales in this period.",
    "emptyBody": "Completed sales and returns at the till appear here. Choose another period.",
    "emptyFiltered": "Nothing for this till or cashier in the period. Remove the filter or choose another period.",
    "hint": "Amounts in <rial/>, VAT included unless marked. Returns are every posted credit note against a till sale, including those raised in the back office, which are not drawer refunds. Net before VAT and discounts are on the sales reports' basis. Sales count on their invoice date, returns on their credit note date, and cash differences on the day the shift closed. Select a till or cashier to narrow the report."
  },
  "taskReport": {
    "title": "Task delivery",
    "teamFilter": "Team",
    "allTeams": "All teams",
    "oneCustomer": "One customer",
    "allCustomers": "Show every customer",
    "printedTeam": "Team: {{team}}",
    "printedCustomer": "Customer: {{customer}}",
    "percent": "{{percent}}%",
    "empty": "No tasks to report.",
    "emptyBody": "Nothing is open, and nothing was due or completed in this period. Choose another period or clear the filters.",
    "clearFilters": "Clear filters",
    "hint": "Figures cover the tasks you can see. Open work is as of today; delivery covers the period. On time means completed on or before the committed due date. Select a figure or a name to open those tasks.",
    "snapshot": {
      "title": "Open work now",
      "asOf": "As of {{date}}",
      "open": "Open",
      "openDetail": "Not yet completed or cancelled",
      "overdue": "Overdue",
      "overdueDetail": "Past their due date",
      "unassigned": "Unassigned",
      "nobodyWaiting": "Nothing is waiting for an assignee",
      "waitUnderADay": "Longest wait under a day",
      "longestWait_one": "Longest wait {{n}} day",
      "longestWait_other": "Longest wait {{n}} days",
      "blocked": "Blocked",
      "blockedDetail": "Waiting on someone or something",
      "inReview": "In review",
      "reviewTime": "Reviews in the period: median {{hours}} h",
      "noReviews": "No review decided in the period",
      "stale_one": "No update for {{n}} day",
      "stale_other": "No update for {{n}} days",
      "staleDetail": "Open, with no meaningful update",
      "customerDue": "Customer work due in 7 days",
      "customerDueBy": "Open, due by {{date}}",
      "figures": "Open work figures"
    },
    "delivery": {
      "title": "Delivery in the period",
      "onTime": "On time",
      "onTimeDetail_one": "{{onTime}} of {{n}} due in the period",
      "onTimeDetail_other": "{{onTime}} of {{n}} due in the period",
      "nothingDue": "Nothing was due in the period",
      "completed": "Completed",
      "completedDetail": "Completed in the period",
      "cycle": "Cycle time",
      "days_one": "{{n}} day",
      "days_other": "{{n}} days",
      "cycleDetail": "Median, from first start to completion",
      "rework": "Rework",
      "reworkDetail": "Completed after a return or a reopening",
      "effort": "Time spent",
      "hours": "{{hours}} h",
      "effortDetail_one": "Against {{estimate}} h estimated, {{n}} task",
      "effortDetail_other": "Against {{estimate}} h estimated, {{n}} tasks",
      "noEffort": "No completed task has both an estimate and time spent",
      "lateLink": "Tasks completed late in the period",
      "figures": "Delivery figures"
    },
    "columns": {
      "open": "Open",
      "overdue": "Overdue",
      "unassigned": "Unassigned",
      "blocked": "Blocked",
      "inReview": "In review",
      "dueInPeriod": "Due in period",
      "onTime": "On time",
      "completed": "Completed"
    },
    "tables": {
      "team": {
        "title": "By team",
        "column": "Team",
        "none": "No team",
        "empty": "No team work to report."
      },
      "person": {
        "title": "By person",
        "column": "Assignee",
        "none": "Unassigned",
        "empty": "No assigned work to report.",
        "note": "Listed by name, not ranked: a count of completed tasks says little about the work behind it."
      },
      "customer": {
        "title": "By customer",
        "column": "Customer",
        "empty": "No customer work to report."
      }
    },
    "leftOut": {
      "title": "What these figures leave out",
      "parents_one": "{{n}} task has subtasks: it is counted through its subtasks, so no work is counted twice.",
      "parents_other": "{{n}} tasks have subtasks: they are counted through their subtasks, so no work is counted twice.",
      "noCommittedDate_one": "{{n}} completed task had no committed due date, so it is not in the on-time figure.",
      "noCommittedDate_other": "{{n}} completed tasks had no committed due date, so they are not in the on-time figure.",
      "noEffort_one": "{{n}} completed task lacks an estimate or the time spent, so it is not in the time figure.",
      "noEffort_other": "{{n}} completed tasks lack an estimate or the time spent, so they are not in the time figure.",
      "nothing": "No task with subtasks, and every completed task had a committed date, an estimate and the time spent.",
      "scope": "Only tasks you can see are counted. Cancelled tasks are not in the delivery figures."
    }
  },
  "projectReports": {
    "searchPlaceholder": "Search project code or name…",
    "searchLabel": "Search projects",
    "status": "Project status",
    "openStatuses": "Open projects",
    "allStatuses": "All, including closed",
    "export": "Export CSV",
    "exported": "Report exported",
    "emptyBody": "Only projects whose money you may see are listed. Choose another status or clear the filters.",
    "profitability": {
      "title": "Project profitability",
      "empty": "No projects to report.",
      "hint": "Amounts in <rial/>. Billed and cost are before VAT; outstanding includes it. Margin is billed less cost to date. Totals cover every project, not only this page. Budget and collected are in the CSV. Select a project to open its budget and costs."
    },
    "budget": {
      "title": "Project budget against actual",
      "empty": "No budgets or costs to report.",
      "hint": "Amounts in <rial/> before VAT, as at the end of the date. Committed is what draft purchases tagged to the project would add. Remaining is budget less actual and committed. Select a category to open its cost lines.",
      "overOnly": "Only at or over the warning level",
      "noCategory": "No category"
    },
    "unbilled": {
      "title": "Unbilled project work",
      "empty": "Nothing waiting to be invoiced.",
      "emptyBody": "Billing items appear here once they are ready, and billable costs once they are posted. Only projects whose money you may see are listed.",
      "hint": "Amounts in <rial/> before VAT. Ready to bill counts billing plan items marked ready; billable costs are time-and-materials costs not yet invoiced. Select an amount to open the project's Billing tab."
    },
    "columns": {
      "project": "Project",
      "customer": "Customer",
      "status": "Status",
      "contract": "Contract",
      "budget": "Budget",
      "billed": "Billed",
      "cost": "Cost to date",
      "margin": "Margin",
      "marginPct": "Margin %",
      "collected": "Collected",
      "outstanding": "Outstanding",
      "category": "Cost category",
      "committed": "Committed",
      "actual": "Actual",
      "remaining": "Remaining",
      "use": "Used",
      "readyItems": "Ready items",
      "readyAmount": "Ready to bill",
      "readySince": "Ready since",
      "tm": "Billable costs",
      "tmOldest": "Oldest cost",
      "total": "Total unbilled",
      "forecastMarginPct": "Expected margin"
    },
    "notMeasured": "Not measured yet"
  },
  "scopeRestricted": {
    "title": "This report covers every purchase",
    "body": "Your access is limited to part of the purchases, so this report is not available to you. Use the purchases list, which shows the ones you can see."
  },
  "salesScopeRestricted": {
    "title": "This report covers every sales document",
    "body": "Your access is limited to part of the sales documents, so this report is not available to you. Use the invoice, receipt and credit note lists, which show the ones you can see."
  },
  "utilisation": {
    "title": "Utilisation",
    "hint": "Hours logged on the projects you can see, by person, over the period. Expected hours come from allocations: allocation × working days × hours per day. Utilisation is approved hours and hours awaiting approval against expected; billable % is the share of them that bills. The org unit is each person's home unit. Cost and billable value show only with the permissions to see them.",
    "columns": {
      "person": "Person",
      "expected": "Expected",
      "approved": "Approved",
      "submitted": "Awaiting approval",
      "billable": "Billable",
      "nonBillable": "Not billable",
      "billablePct": "Billable %",
      "utilisationPct": "Utilisation %",
      "cost": "Cost",
      "value": "Billable value"
    },
    "filters": {
      "orgUnit": "Org unit",
      "allUnits": "All units",
      "project": "Project",
      "allProjects": "All projects",
      "oneProject": "The chosen project",
      "person": "Person",
      "everyone": "Everyone",
      "onePerson": "The chosen person",
      "clear": "All projects"
    },
    "projects_one": "{{n}} project",
    "projects_other": "{{n}} projects",
    "empty": "No time logged in this period.",
    "emptyBody": "Only time on projects you can see is counted. Choose another period or clear the filters.",
    "tooLong": "A utilisation period covers at most 366 days. Choose a shorter period."
  },
  "salesBySalesperson": {
    "title": "Sales by salesperson",
    "hint": "Each invoice is credited to its salesperson: their invoices, returns, gross profit and what customers paid on them. Sales and collections by user credits whoever recorded the invoice instead.",
    "none": "No salesperson",
    "empty": "No sales in this period",
    "emptyBody": "Choose another period."
  }
}
